export default __webpack_public_path__ + "static/media/dapulse.8655a659.svg";